import { writable } from 'svelte/store';

// Debug settings
export const DEBUG_CONFIG = writable({
  showDebugPanels: false,      // Master toggle for all debug panels
  logContainerDetection: false, // Log container detection messages
  logShapeMatching: false,     // Log shape matching details
  logFloorChanges: false,       // Log floor change events
  logSvgUpdates: false,        // Log SVG update events
});

// Default configuration options for the map viewer
export const DEFAULT_MAP_CONFIG = {
  // Pan/zoom options
  minZoom: 0.8,
  maxZoom: 5,
  panLimit: 400,
  allowPan: true,        // Allow map panning
  allowZoom: true,       // Allow map zooming
  wheelZoom: true,       // Allow mouse wheel zooming
  panSensitivity: 25,     // Adjust pan speed
  zoomSensitivity: 25,    // Adjust zoom speed
  
  // UI controls
  showZoomControls: true,    // Show zoom in/out buttons
  showFloorControls: true,   // Show floor navigation controls
  showFloorNames: true,      // Show floor names instead of numbers
  showStatusDisplay: false,  // Show viewbox coordinates and zoom level
  showBoundaryIndicators: false, // Show visual indicators when limits are reached
  showStoreSidebar: true,    // Show the store search and list sidebar
  
  // Store interaction
  enableStoreClick: true,    // Enable clicking on stores
  enableStoreHover: true,    // Enable hover effects on stores
  showStorePins: true,       // Show store pins on the map
  showLabels: true,          // Show store labels on the map
  
  // Shape highlighting on hover/click
  shapeHighlighting: {
    fillColor: 'rgba(66, 133, 244, 0.95)',
    strokeColor: '#4285f4',
    strokeWidth: '1px',
    opacity: 0.4,
  },

  // Store pin styling
  storePins: {
    fillColor: {
      active: '#4285f4',
      inactive: '#FFFFFF',
    },
    strokeColor: {
      active: '#FFFFFF',
      inactive: '#4285f4',
    },
    strokeWidth: {
      active: '2px',
      inactive: '1px',
    },
    bigShapeSize: 1.6,
    mediumShapeSize: 1.3,
    smallShapeSize: 1.0,
    activeSizeMultiplier: 1.2,
    yOffset: 0,
  },
  
  // Label styling
  labelStyling: {
    fontFamily: 'Arial, sans-serif',
    fontWeight: 'bold',
    textColor: '#000000',
    textShadow: '0 0 2px rgba(255,255,255,0.7)', // A light shadow for better readability on dark shapes
    bigShapeFontSize: '16px',
    mediumShapeFontSize: '12px',
    smallShapeFontSize: '10px',
    yOffset: 12,
    showLabelOnHover: true, // Show label on hover regardless of zoom level
    hoverBackgroundColor: 'rgba(255, 255, 255, 0.8)',
    hoverBorderRadius: '4px',
    hoverVerticalPadding: '2px',
    hoverHorizontalPadding: '4px',
  },

  // Dynamic labeling based on zoom level and shape area
  dynamicLabeling: {
    enabled: true,
    smallAreaThreshold: 4000,
    mediumAreaThreshold: 10000,
    mediumLabelZoomThreshold: 150, // e.g., show medium labels at 150% zoom and above
    smallLabelZoomThreshold: 200,   // e.g., show small labels at 200% zoom and above
  },
  
  // Zoom level when focusing on a specific store (e.g., 2 = 200% zoom)
  storeZoomFactor: 2.5,
};

// Helper function to toggle debug mode (can be called from console)
export function toggleDebugPanels(): void {
  DEBUG_CONFIG.update(config => {
    const newState = !config.showDebugPanels;
  if (newState) {
    console.log(`Debug panels are now ENABLED (master toggle ON)`);
  }
    return { ...config, showDebugPanels: newState };
  });
}

// Make all toggle functions globally accessible for testing
if (typeof window !== 'undefined') {
  (window as any).toggleMapDebug = toggleDebugPanels;
} 